<template>
  <div class="popup-card">
    <div class="popup-card_bg">
      <img :src="`/static/image/air-monitor/${state}-card.png`" alt="" />
    </div>
    <div class="close-btn" @click.stop="handleClose">
      <i class="iconfont icon-close"></i>
    </div>
    <div class="popup-card_content">
      <div class="popup-card_content-left">
        <i v-if="info.icon != 'icon-custom'" :class="['iconfont', info.icon]"></i>
        <div v-else class="icon-custom">{{ $t('毒') }}</div>
      </div>
      <div class="popup-card_content-right">
        <div class="popup-card_content-title">{{ info.title }}</div>
        <div class="popup-card_content-info">
          <div class="popup-card_content-info-type">
            <span>{{ $t('类型') }}：</span>
            <span>{{ info.type }}</span>
          </div>
          <div class="popup-card_content-info-location">
            <span>{{ $t('位置') }}：</span>
            <span :title="info.location">{{ info.location }}</span>
          </div>
        </div>
        <div class="popup-card_content-btns">
          <el-button
            type="primary"
            v-for="btn in btns"
            :key="btn.text"
            size="mini"
            @click="btn.onClick(info)"
          >
            {{ btn.text }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    state: {
      type: String,
      default: 'offline'
    },
    info: {
      type: Object,
      default: () => ({})
    },
    btns: {
      type: Array,
      default: () => []
    },
    onClose: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.dispose();
      this.onClose();
    },
    dispose() {
      // if appendToBody is true, remove DOM node after destroy
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    }
  }
};
</script>

<style lang="scss">
.popup-card {
  position: absolute;
  left: 0;
  top: 0;

  transform: translate(68px, -100%);

  width: 374px;
  height: 124px;

  cursor: default;

  &_bg {
    position: absolute;
    left: 0;
    top: 0;

    z-index: 1;

    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .close-btn {
    position: absolute;
    right: 3%;
    top: 9%;
    z-index: 3;

    cursor: pointer;

    transition: 0.3s transform;

    &:hover {
      transform: rotate(-90deg);
    }
  }

  &_content {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;

    width: 100%;
    height: 100%;
    display: flex;

    &-btns {
      .el-button {
        width: 30%;

        border: 0;
        color: #fff;
        background: linear-gradient(360deg, #0043f8 0%, #0075f8 100%);
      }
    }

    &-left {
      width: 27%;
      display: flex;
      justify-content: center;
      align-items: center;

      .iconfont {
        font-size: 50px;
      }

      .icon-custom {
        font-size: 36px;
        font-weight: bold;
      }
    }

    &-right {
      width: 70%;
      padding: 20px 10px;
      box-sizing: border-box;
    }

    &-title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
      text-shadow: 0px 4px 4px rgba(11, 25, 46, 0.4);
      line-height: 1;
    }

    &-info {
      display: flex;
      gap: 10px;
      line-height: 40px;
      font-size: 14px;
      color: #ffffff;
      text-shadow: 0px 4px 4px rgba(11, 25, 46, 0.4);

      &-type {
        min-width: 90px;
      }

      &-location {
        @include ellipsis-style;
      }
    }
  }
}
</style>
